import { Heading } from "@otrium/atoms";
import { ReactNode } from "react";
import { Skeleton } from "src/atoms/Skeleton";
import { theme } from "src/theme";
import { ShopType } from "src/types/graphql.d";

function Header({
  title,
}: {
  slug: string;
  shopType: ShopType;
  title: string | ReactNode;
}): JSX.Element {
  if (!title) {
    return <Skeleton width={"250px"} height={theme.typography.fontSize._32} />;
  }

  return (
    <>
      <Heading
        data-testid="page-title"
        as="h1"
        variant="h2"
        fontSize={["20px", "20px", "28px", "28px"]}
        sx={{
          textTransform: "uppercase",
          letterSpacing: "1.8px",
          fontWeight: "700",
          color: "#000000",
        }}
      >
        {title}
      </Heading>
    </>
  );
}

export { Header };
